import React from "react";
import { fuzzyFilter } from "./customFilters";

export const FuzzyHighlighter = (text: string, search: string) => {
    if (!search) return text;

    if (!fuzzyFilter(text, search)) return text;

    const matchedIndexes = findMatchIndices(text, search);

    let lastIndex = 0;
    const highlighted = [];

    matchedIndexes.forEach(([start, end], i) => {
        if (lastIndex < start) {
            highlighted.push(text.substring(lastIndex, start));
        }

        highlighted.push(
            <span key={i} style={{ backgroundColor: "yellow" }}>
                {text.substring(start, end + 1)}
            </span>
        );

        lastIndex = end + 1;
    });

    if (lastIndex < text.length) {
        highlighted.push(text.substring(lastIndex));
    }

    return highlighted;
};


const findMatchIndices = (text: string, search: string) => {
    const lowerText = text.toLowerCase();
    const lowerSearch = search.toLowerCase();
    let matchIndices: [number, number][] = [];
    let startIndex = 0;

    for (let i = 0; i < lowerSearch.length; i++) {
        const index = lowerText.indexOf(lowerSearch[i], startIndex);
        if (index !== -1) {
            if (matchIndices.length > 0 && matchIndices[matchIndices.length - 1][1] === index - 1) {
                matchIndices[matchIndices.length - 1][1] = index;
            } else {
                matchIndices.push([index, index]);
            }
            startIndex = index + 1;
        }
    }

    return matchIndices;
};
